import { Box, ButtonBase } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Button } from "react-bootstrap";

const CustomButton = ({ btnType = null, tittle = "Primary Btn", btnwidth = '150px', bcolor = '#fff', tcolor = 'rgb(144,202,37)', onClick = null}) => {
  return (
    <Box>
          <ButtonBase
            type={btnType}
            onClick={onClick}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: 'center',
              gap: "0",
              textDecoration: "none",
              position: 'relative',
              width: `${btnwidth}`
            }}
          >
            <div style={{flex: 1, backgroundColor: `${bcolor}`, border: 'none', color: `${tcolor}`, borderRadius: '25px', padding: '.6rem 1rem'}}>
              {tittle}
            </div>
            <div style={{backgroundColor: `${tcolor}`, width: '35px', height: '35px', borderRadius: '50%', border: `.3rem solid ${bcolor}`, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <ArrowOutwardIcon sx={{color: `${bcolor}`}} />
            </div>
            <Box></Box>
            <div style={{position: 'absolute', width: '80%', height: '50%', backgroundColor: `${bcolor}`, zIndex: '-1'}}></div>
          </ButtonBase>
    </Box>
    
  );
};

export default CustomButton;
